// extracted by mini-css-extract-plugin
module.exports = {"home":"style_home__24Eih"};